const stylesService = {
  stack: {
    width: "100%",
    marginTop: "1rem",
  },
  stackb: {
    width: "6rem",
    marginTop: "1rem",
    marginLeft: "30rem",
  },
  stackc: {
    width: "6rem",
    marginTop: "2rem",
    marginLeft: "1rem",
  },
};

export default stylesService;
